import React, { useEffect, useMemo, useRef, useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderMobile from "../layouts/HeaderMobile";
import blogPosts from "../data/BlogPosts";

const PAGE_SIZE = 6;

export default function BlogList() {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [isLoading, setIsLoading] = useState(false);
  const loaderRef = useRef(null);
  const loadingRef = useRef(false);

  const visiblePosts = useMemo(() => {
    return blogPosts.slice(0, visibleCount);
  }, [visibleCount]);

  const hasMore = visibleCount < blogPosts.length;

  useEffect(() => {
    if (!loaderRef.current || !hasMore) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting || loadingRef.current) {
          return;
        }

        loadingRef.current = true;
        setIsLoading(true);

        window.setTimeout(() => {
          setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, blogPosts.length));
          loadingRef.current = false;
          setIsLoading(false);
        }, 350);
      },
      { rootMargin: "200px" }
    );

    observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [hasMore]);

  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main-blog p-4 p-lg-5">
        <div className="blog-header">
          <div className="blog-kicker">GuruWhisper Blog</div>
          <h1 className="blog-title">블로그</h1>
          <p className="blog-subtitle">
            금융 데이터와 투자 인사이트를 쉽고 빠르게 정리합니다.
          </p>
        </div>

        <div className="blog-list">
          {visiblePosts.map((post) => {
            const hasImage = Boolean(post.image);
            return (
            <Link
              to={`/intro/blog/${post.id}`}
              className="blog-item"
              key={post.id}
            >
              <Row className="align-items-center g-3">
                <Col md={hasImage ? 8 : 12} className="order-2 order-md-1">
                  <div className="blog-meta">
                    <Badge bg="light" text="dark">{post.category}</Badge>
                    <span>{post.date}</span>
                    <span>{post.readingTime}분 읽기</span>
                  </div>
                  <h4 className="blog-item-title">{post.title}</h4>
                  <p className="blog-item-summary mb-0">{post.summary}</p>
                </Col>
                {hasImage ? (
                  <Col md={4} className="order-1 order-md-2">
                    <div
                      className="blog-thumb"
                      role="img"
                      aria-label={post.title}
                      style={{ backgroundImage: `url(${post.image})` }}
                    />
                  </Col>
                ) : null}
              </Row>
            </Link>
            );
          })}
        </div>

        <div className="blog-loader text-center" ref={loaderRef}>
          {hasMore ? (
            <span className="text-secondary">
              {isLoading ? "콘텐츠 불러오는 중..." : "스크롤해서 더 보기"}
            </span>
          ) : (
            <span className="text-secondary">마지막 글입니다.</span>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
